import { useState } from 'react'
import ConfirmationDialog from '../../Components/Common/ConfirmationDialog'

interface ConfirmationAlertOptions {
  title?: string
  text?: string
  confirmButtonText?: string
  cancelButtonText?: string
  onConfirm: () => void
  onCancel?: () => void
}

const useConfirmationAlert = () => {
  const [dialogOptions, setDialogOptions] = useState<ConfirmationAlertOptions | null>(null)
  const [open, setOpen] = useState(false)

  const openConfirmationAlert = (options: ConfirmationAlertOptions) => {
    setDialogOptions(options)
    setOpen(true)
  }

  const handleConfirm = () => {
    if (dialogOptions?.onConfirm) {
      dialogOptions.onConfirm()
    }
    closeConfirmationAlert()
  }

  const handleCancel = () => {
    if (dialogOptions?.onCancel) {
      dialogOptions.onCancel()
    }
    closeConfirmationAlert()
  }

  const closeConfirmationAlert = () => {
    setOpen(false)
    setDialogOptions(null)
  }

  const ConfirmationAlert = (
    <>
      {dialogOptions && (
        <ConfirmationDialog
          open={open}
          title={dialogOptions.title}
          text={dialogOptions.text}
          confirmButtonText={dialogOptions.confirmButtonText}
          cancelButtonText={dialogOptions.cancelButtonText}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
    </>
  )

  return { ConfirmationAlert, openConfirmationAlert }
}

export default useConfirmationAlert
